<template>
  <div class="page login-page">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">登录云系统</h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-before">
              <div class="weui-cell__hd" @click="selectAreaCode"><div class="weui-select">{{ '+' + countryCode }}</div></div>
              <div class="weui-cell__bd">
                <input
                  v-model="mobile"
                  class="weui-input"
                  placeholder="请输入手机号"
                />
              </div>
              <!-- <div class="weui-cell__ft" v-show="!isMobileValid">
                <a class="weui-btn_reset weui-btn_icon">
                  <i class="weui-icon-info-circle"></i>
                </a>
              </div> -->
            </div>
            <div class="weui-cell weui-cell_active weui-cell_vcode">
              <div class="weui-cell__bd">
                <input
                  v-model="validCode"
                  class="weui-input"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="weui-cell__ft" @click="getValidCode">
                <button
                  class="weui-btn weui-btn_default weui-vcode-btn"
                  :class="{ 'weui-btn_disabled': isLocked }"
                >
                  <span v-if="!waitTime">获取验证码</span
                  ><span v-else>{{ waitTime }}秒后再试</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area opr-block">
        <a
          class="weui-btn weui-btn__auto weui-btn_primary"
          :class="{ 'weui-btn_disabled': !isValidForm }"
          @click="login"
          >登录</a
        >
      </div>
      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__links">
            <router-link :to="registerUrl" class="weui-footer__link"
              >免费注册</router-link
            >
            <a v-if="isTablet" @click="switchDesktop" class="weui-footer__link"
              >切换到电脑版</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "@/util/validator.js";
import wait from "@/mixins/wait.js";
import captcha from "@/mixins/captcha.js";
import Auth from "@/util/auth.js";
const desktopUrl = process.env.VUE_APP_DESKTOP_URL;

export default {
  mixins: [wait, captcha],
  data() {
    return {
      mobile: null,
      countryCode: '86',
      validCode: null,
      unionid: null,
      inviteCode: null,
      partnerUU: null,
      partnerUser: null
    };
  },
  computed: {
    isMobileValid() {
      return Validator.isMobile(this.mobile);
    },
    isLocked() {
      const me = this;
      return !me.isMobileValid || me.isWaiting;
    },
    isValidForm() {
      const me = this;
      return me.isMobileValid && me.validCode;
    },
    registerUrl() {
      var fullPath = this.$route.fullPath,
        index = fullPath.indexOf("?"),
        url = "/register";
      if (index > 0) {
        url += fullPath.substr(index);
      }
      return url;
    },
    isTablet() {
      const userAgent = window.navigator.userAgent;
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      return /Tablet|Android|Mobi|iPhone/i.test(userAgent) || (screenWidth >= 768 && screenWidth <= 1024);
    }
  },
  mounted() {
    // 来自微信端，带有微信身份
    this.unionid = this.$route.query.unionid;
    // 来自顾问邀请
    this.inviteCode = this.$route.query.inviteCode;
    // 来自合作伙伴邀请
    this.partnerUU = this.$route.query.partner;
    this.partnerUser = this.$route.query.partnerUser;
  },
  methods: {
    selectAreaCode() {
      this.$weui.areaCodePicker((result) => {
        let label = result[0].label
        this.countryCode = label.substring(label.indexOf('+') + 1)
      })
    },
    /**
     * 获取验证码
     */
    getValidCode() {
      const me = this;
      if (me.isLocked) {
        return;
      }
      me.$captcha.show();
      me.$bus.$on('getTicket', res => {
        if (res.ret === 0) {
          me.addWaitTask();
          me.$loading({
            url: "/api/auth/authorize/vcode",
            method: "POST",
            params: {
              mobile: me.mobile,
              countryCode: me.countryCode,
              ticket: res.ticket,
              appId: res.appid,
              randstr: res.randstr
            },
          }).then(function (res) {
            if (res.success) {
              me.$weui.toast("发送成功", 2000);
            } else {
              me.$weui.topTips("发送失败", 3000);
              me.clearWaitTask();
            }
          });
        } else {
          me.$weui.topTips('未通过验证');
        }
        me.$bus.$off('getTicket')
      })
    },
    /**
     * 登录
     */
    login() {
      const me = this, companyId = me.$route.query.companyId || null;
      if (!me.isValidForm) {
        return;
      }
      me.$loading({
        url: "/api/auth/authorize",
        method: "POST",
        params: {
          mobile: me.mobile,
          validCode: me.validCode,
          companyId
        },
      }).then(function (res) {
        if (res.success) {
          let authData = res.data;
          Auth.set(authData);
          if (me.unionid) {
            // 绑定微信账号
            me.bindWeixin(me.unionid, authData.token.token).then(function () {
              if (!authData.companyId) {
                // 出现该情况是用户还未绑定企业，需要提醒用户开通企业或找管理员绑定
                me.applyAppFromSso(authData.account);
              } else {
                // 来自合伙人邀请
                if (me.inviteCode) {
                  me.checkAdviserStatus(me.inviteCode, authData);
                } else if (me.partnerUU) {
                  me.checkPartnerStatus(me.partnerUU, me.partnerUser, authData);
                } else {
                  me.redirectApp(authData);
                }
              }
            });
          } else {
            if (!authData.companyId) {
              // 出现该情况是用户还未绑定企业，需要提醒用户开通企业或找管理员绑定
              me.applyAppFromSso(authData.account);
            } else {
              // 来自合伙人邀请
              if (me.inviteCode) {
                me.checkAdviserStatus(me.inviteCode, authData);
              } else if (me.partnerUU) {
                me.checkPartnerStatus(me.partnerUU, me.partnerUser, authData);
              } else {
                me.redirectApp(authData);
              }
            }
          }
        } else {
          me.$weui.topTips("登录失败：" + res.message, 3000);
        }
      });
    },

    /**
     * 选择需要开通saas的企业(sso中绑定的企业)
     */
    applyAppFromSso(account) {
      const me = this;
      me.getSsoCompanies(account.mobile).then(function (companies) {
        if (companies && companies.length) {
          if (companies.length == 1) {
            me.redirectRegister(account, companies[0], companies);
          } else {
            let items = companies.map((c) => {
              return {
                label: c.name,
                value: c,
              };
            });
            me.$weui.picker(items, {
              title: "选择企业，开通云系统",
              onConfirm: function (result) {
                me.redirectRegister(account, result[0].value, companies);
              },
            });
          }
        } else {
          me.$weui.topTips(
            "您的账号还未绑定企业，请先注册或找您的企业管理员绑定账号！",
            3000
          );
        }
      });
    },
    /**
     * 查找sso中绑定的企业
     */
    getSsoCompanies(mobile) {
      const me = this;
      return me
        .$ajax({
          url: "/api/account/account/sso_companies",
          params: {
            mobile,
          },
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
    },
    /**
     * 跳转开通企业应用
     */
    redirectRegister(account, company, companies) {
      const me = this;
      me.$router.push({
        name: "AutoRegister",
        params: {
          signInfo: {
            mobile: account.mobile,
            userName: account.realname,
            companyName: company.name
          },
          companies,
          inviteCode: me.inviteCode,
          partner: me.partnerUU,
          partnerUser: me.partnerUser
        },
      });
    },
    /**
     * 绑定微信账号
     */
    bindWeixin(unionid, token) {
      return this.$loading({
        url: "/api/weixin/bind",
        method: "POST",
        headers: {
          Authorization: token,
        },
        params: {
          unionid,
        },
      });
    },
    /**
     * 检查绑定顾问的状态
     */
    checkAdviserStatus(inviteCode, authData) {
      const me = this;
      me.$ajax({
        url: "/api/account/partner/customer/status",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data;
          if (data.hasPartner) {
            let partner = data.customer.partner;
            me.$weui.alert(
              `您已经绑定了顾问 ${partner.name}`,
              {
                title: "警告",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else if (data.inviter) {
            me.$weui.confirm(
              `${data.inviter.name} 将成为您企业(${authData.account.defaultCompany.name})的专属顾问`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "不同意",
                    type: "default",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                  {
                    label: "同意",
                    type: "primary",
                    onClick: function () {
                      me.bindAdviser(inviteCode, authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    redirectApp(authData) {
      var page = this.$route.query.page, portal = this.$route.query.portal;
      if (page && page.indexOf('https') == 0) {
        window.location.href = page;
      } else {
        if (!page) {
          // portal = b2b/process/report/profile
          page = "/" + authData.appId.replace("-app", "") + (portal ? ('/' + portal) : '');
        }
        this.$router.replace(page);
      }
    },
    /**
     * 绑定顾问
     */
    bindAdviser(inviteCode, authData) {
      const me = this;
      me.$loading({
        url: "/api/account/partner/customer/open",
        method: 'post',
        params: {
          inviteCode
        }
      }).then(function(res){
        if (res.success) {
          let data = res.data;
          if (!data.hasPartner) {
            me.$weui.alert(
              `绑定顾问失败`,
              {
                title: "出错了",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.$weui.alert(
              `${data.inviter.name} 是您的专属顾问了`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function(){
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    /**
     * 检查绑定合作伙伴的状态
     */
    checkPartnerStatus(enuu, userUU, authData) {
      const me = this;
      if (authData.account.defaultCompany.uu == enuu) {
        // 扫自己公司二维码的情况
        me.redirectApp(authData);
        return;
      }
      me.$ajax({
        url: "/api/account/company_partner/status",
        params: {
          enuu,
          userUU
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data, partner = data.partner;
          if (data.hasPartner || data.hasApply) {
            let message = data.hasPartner ? `已经绑定了合作伙伴${partner.name}`
              : `正在申请与${partner.name}合作`;
            me.$weui.alert(
              `您的企业(${authData.account.defaultCompany.name})${message}`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else if (partner) {
            me.$router.push({
              name: "ApplyPartner",
              params: { partner, authData, partnerUser: me.partnerUser }
            });
          } else {
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function(){
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    switchDesktop() {
      window.location.href = desktopUrl + '/trade/?deviceType=Desktop#login';
    }
  },
};
</script>

<style scoped>
.opr-block {
  padding: 0 32px;
}
</style>

